import { FunctionsHttpError } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

export type OneDriveStatus = { enabled: boolean; connected: boolean; email: string | null; reconnectRequired: boolean };
export type OneDriveFile = { id: string; driveId: string; name: string; mimeType: string; modifiedTime: string | null; isFolder: boolean };

/** Calls the Microsoft Files (OneDrive) capability of `microsoft-connect`. Read-only, caller's own permissions. */
export async function callOneDrive<T>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke('microsoft-connect', { body: { capability: 'files', ...body } });
  if (error) {
    let msg = 'Something went wrong with OneDrive.';
    if (error instanceof FunctionsHttpError) {
      const parsed = await error.context.json().catch(() => null);
      if (typeof parsed?.error === 'string' && !parsed.request_id) msg = parsed.error;
    }
    throw new Error(msg);
  }
  return data as T;
}

export function base64ToFile(b64: string, name: string, type: string) {
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new File([bytes], name, { type });
}
